import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryFuelComponent } from './tractors-history-fuel.component';
import {DxChartModule, DxDataGridModule, DxLoadPanelModule, DxScrollViewModule, DxToolbarModule} from 'devextreme-angular';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';
import {GridTitleModule} from 'shared';



@NgModule({
  declarations: [TractorsHistoryFuelComponent],
    imports: [
        CommonModule,
        DxChartModule,
        DxoValueAxisModule,
        DxLoadPanelModule,
        DxToolbarModule,
        DxDataGridModule,
        GridTitleModule,
        DxScrollViewModule
    ],
  exports: [TractorsHistoryFuelComponent]
})
export class TractorsHistoryFuelModule { }
